import React from 'react';
import { Box, LinearProgress } from '@medely/ui-kit';
import { useApplicationProgress } from '../applicationProgress';

export const ApplicationProgressIndicator = () => {
  const progress = useApplicationProgress();

  if (!progress) {
    return null;
  }

  return (
    <Box width="100%">
      <LinearProgress percent={progress.percent} variant="squared" />
    </Box>
  );
};
